"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Store_1 = require("../Store");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
let SearchInput = class SearchInput extends React.Component {
    onChange(e) {
        Store_1.default.query = e.target.value;
    }
    onKeyPress(e) {
        if (e.key === 'Enter') {
            Store_1.default.Search(true);
        }
    }
    render() {
        return (React.createElement("div", { className: "search-panel-div" },
            React.createElement("input", { id: "search-field", className: "s-h3", type: "text", value: Store_1.default.query, onChange: this.onChange, onKeyPress: this.onKeyPress }),
            React.createElement("div", { className: "c-button-common", onClick: () => Store_1.default.Search(true) }, Store_1.default.translations.searchButton)));
    }
};
__decorate([
    mobx_1.action.bound
], SearchInput.prototype, "onChange", null);
__decorate([
    mobx_1.action.bound
], SearchInput.prototype, "onKeyPress", null);
SearchInput = __decorate([
    mobx_react_1.observer
], SearchInput);
exports.default = SearchInput;
